import { useState } from 'react'
import { Link, useNavigate } from 'react-router'
import { KeyRound } from 'lucide-react'
import { sshKeys as keyApi } from '@/api/endpoints'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { Err } from '@/components/Err'
import { PageHead } from '@/components/layout/Page'

// 새 SSH 키(#627) — GitHub 의 Add new SSH Key 와 같다: 제목, 키, `SSH 키 추가`. 키 종류는 인증 키 하나뿐이라 고르지 않는다.
// 붙여 넣은 그대로 보내고 판정은 백엔드가 한다(쓸 수 없는 키 400, 이미 등록된 키·이름 409). 되면 목록으로 돌아간다.
const KEY_PLACEHOLDER = "'ssh-ed25519', 'ecdsa-sha2-nistp256', 'ecdsa-sha2-nistp384', 'ecdsa-sha2-nistp521', 'ssh-rsa' 로 시작합니다"

export default function NewSshKey() {
  const nav = useNavigate()
  const [name, setName] = useState('')
  const [publicKey, setPublicKey] = useState('')
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState<unknown>(null)
  const submit = async (e: React.FormEvent) => {
    e.preventDefault()
    setBusy(true)
    setError(null)
    try {
      await keyApi.create({ name: name.trim(), public_key: publicKey.trim() })
      void nav('/me/keys')
    } catch (err) {
      setError(err)
      setBusy(false)
    }
  }
  return (
    <>
      <PageHead icon={<KeyRound className="size-5" />} title="새 SSH 키" />
      <form onSubmit={submit} className="grid max-w-2xl gap-4 pt-4">
        <div className="grid gap-1.5">
          <Label htmlFor="key-name">제목</Label>
          <Input id="key-name" value={name} disabled={busy} onChange={(e) => setName(e.target.value)} maxLength={100} />
        </div>
        <div className="grid gap-1.5">
          <Label htmlFor="key-public">키</Label>
          <textarea
            id="key-public"
            value={publicKey}
            disabled={busy}
            onChange={(e) => setPublicKey(e.target.value)}
            rows={8}
            spellCheck={false}
            placeholder={KEY_PLACEHOLDER}
            className="w-full rounded-md border border-input bg-transparent px-3 py-2 font-mono text-[12px] shadow-xs outline-none focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50"
          />
        </div>
        <Err error={error} />
        <div className="flex items-center gap-2">
          <Button type="submit" disabled={busy || !name.trim() || !publicKey.trim()} className="bg-brand hover:bg-brand-hover">
            {busy ? '추가 중' : 'SSH 키 추가'}
          </Button>
          <Button asChild variant="outline">
            <Link to="/me/keys">취소</Link>
          </Button>
        </div>
      </form>
    </>
  )
}
